module.exports = __webpack_public_path__ + "img/icon_system_dictionary_import.d2bdc27d.svg";